import {
  GetRenewalWithAgencyDataQueryResult,
  GetRenewalWithCheckReceivalQueryResult,
  useGetRenewalWithAgencyDataQuery,
  useGetRenewalWithCheckReceivalQuery,
} from "@covertree/agent-portal-graphql";

export function useGetRenewal(
  renewalLocator: string,
  canMarkRenewalAsPaid: boolean
):
  | GetRenewalWithCheckReceivalQueryResult
  | GetRenewalWithAgencyDataQueryResult {
  if (canMarkRenewalAsPaid) {
    return useGetRenewalWithCheckReceivalQuery({
      variables: { renewalLocator },
      fetchPolicy: "cache-and-network",
    });
  }

  return useGetRenewalWithAgencyDataQuery({
    variables: { renewalLocator },
    fetchPolicy: "cache-and-network",
  });
}
